<template>
    <div>
        <Spin size="large" fix v-if="loading" />
        <div v-else>
            <div v-if="list.length === 0">本期账单暂无已开收据</div>
            <div v-else>
                <img
                    v-for="(item, index) in list"
                    :key="index"
                    :src="item.imgUrl"
                    class="receipt-class"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        list: {
            type: Array,
            default: [],
        },
    },
};
</script>

<style lang="less" scoped>
.receipt-class {
    width: 760px;
}
</style>
